import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AppIconEntity } from '@nk/data-entities-lib';

@Component({
  selector: 'nk-flag-icon',
  imports: [],
  templateUrl: './flag-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlagIconComponent {
  public appIcon = input.required<AppIconEntity>();
  /**
   * one of lg, 2x, 3x etc.. See fontawesome documentation (fa- will be prefixed)
   */
  public size = input<string>('');
  public title = input<string>('');
  public andClass = input<string>('');
  public colorClassOverride = input<string>('');
}
